import { ApdmReplyDraftReviewMessage } from '@euler/model/apdm';

/** Who sent a message of the conversation, as the reviewer reads it. */
export function senderLabel(
  sender: ApdmReplyDraftReviewMessage['sender'],
): string {
  return sender === 'customer'
    ? '客户'
    : sender === 'staff'
    ? '顾问'
    : '自动消息';
}
